/**
 * `/inbox` — the notification table and its detail panel.
 *
 * One `RouteObject`, so the file is `inbox.route.tsx` (singular). An aggregate
 * array would be `inbox.routes.tsx`, and the importer knows the shape from the
 * name.
 *
 * The route resolves nothing and fetches nothing: **no `loader` in this repo
 * performs a data read.** The sort rides `useSearchParams` in the page
 * component, and the cursor stack is component state — neither is a param a
 * loader would have to validate before painting.
 *
 * The chunk is split through the router's OWN `lazy` rather than
 * `React.lazy`: the data router awaits it before it renders the match, so the
 * feature needs no `Suspense` boundary of its own.
 */
import type { RouteObject } from 'react-router-dom';

export const inboxRoute: RouteObject = {
  path: 'inbox',
  lazy: async () => {
    const { InboxPage } = await import('./InboxPage');
    return { Component: InboxPage };
  },
};
